<script>
  import Sidebar from "../components/Sidebar/Sidebar.svelte";
  import AdminNavbar from "../components/Navbars/AdminNavbar.svelte";
  import FooterAdmin from "../components/Footers/FooterAdmin.svelte";
</script>

<div class="min-h-screen bg-canvas">
  <Sidebar />
  <div class="md:pl-64 flex flex-col min-h-screen">
    <AdminNavbar />
    <main class="flex-1 w-full max-w-7xl mx-auto px-4 md:px-8 py-8 fade-in">
      <slot />
    </main>
    <FooterAdmin />
  </div>
</div>
